document.addEventListener("DOMContentLoaded", () => {
  const searchToggle = document.querySelector("[data-mobile-search-toggle]");
  const searchPanel = document.getElementById("office_mobile_search");

  if (!searchToggle || !searchPanel) return;

  const searchInput = searchPanel.querySelector("input[type='text']");
  const navbarBurger = document.querySelector(".office-navbar .navbar-burger");
  const navbarMenu = document.getElementById("main_navbar");

  const setSearchOpen = (open) => {
    searchPanel.classList.toggle("is-active", open);
    searchToggle.classList.toggle("is-active", open);
    searchToggle.setAttribute("aria-expanded", open.toString());

    if (open) searchInput?.focus();
  };

  searchToggle.addEventListener("click", () => {
    const opening = !searchPanel.classList.contains("is-active");

    if (opening) {
      navbarBurger?.classList.remove("is-active");
      navbarBurger?.setAttribute("aria-expanded", "false");
      navbarMenu?.classList.remove("is-active");
    }

    setSearchOpen(opening);
  });

  navbarBurger?.addEventListener("click", () => setSearchOpen(false));

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") setSearchOpen(false);
  });
});
